import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contex/AuthContext";

export default function SignupScreen() {
  const { signUp, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setLoading(true);
    try {
      await signUp(email, password, { name });
      navigate("/onboarding");
    } catch (err) {
      if (err.code === "auth/email-already-in-use") {
        setError("This email is already registered. Please sign in.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
    setLoading(false);
  };

  const handleGoogle = async () => {
    setError("");
    setLoading(true);
    try {
      await signInWithGoogle();
      navigate("/onboarding");
    } catch (err) {
      setError("Google sign-in failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.logo}>Study<span style={{color:"#7C6EF8"}}>OS</span></div>
      <div style={styles.tagline}>Create your account 🎓</div>

      <form onSubmit={handleSignup} style={styles.form}>
        <div style={styles.group}>
          <label style={styles.label}>First name</label>
          <input style={styles.input} type="text" placeholder="e.g. Kwame"
            value={name} onChange={e => setName(e.target.value)} required />
        </div>
        <div style={styles.group}>
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" placeholder="your@email.com"
            value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div style={styles.group}>
          <label style={styles.label}>Password</label>
          <input style={styles.input} type="password" placeholder="Min. 8 characters"
            value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        <div style={styles.group}>
          <label style={styles.label}>Confirm password</label>
          <input style={styles.input} type="password" placeholder="Repeat password"
            value={confirm} onChange={e => setConfirm(e.target.value)} required />
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.primaryBtn} type="submit" disabled={loading}>
          {loading ? "Creating account..." : "Create account"}
        </button>
      </form>

      <button style={styles.googleBtn} onClick={handleGoogle} disabled={loading}>
        <span>G</span> Sign up with Google
      </button>

      <Link to="/login" style={styles.link}>Already have an account? Sign in</Link>
    </div>
  );
}

const styles = {
  wrap:       { minHeight:"100vh", background:"#0F0F13", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px" },
  logo:       { fontSize:"32px", fontWeight:700, color:"#F0EFE8", letterSpacing:"-1px", marginBottom:"8px" },
  tagline:    { fontSize:"16px", color:"#9998A0", marginBottom:"40px" },
  form:       { width:"100%", maxWidth:"360px" },
  group:      { marginBottom:"16px" },
  label:      { display:"block", fontSize:"12px", fontWeight:600, color:"#9998A0", textTransform:"uppercase", letterSpacing:".06em", marginBottom:"6px" },
  input:      { width:"100%", padding:"14px 16px", background:"#18181F", border:"1px solid rgba(255,255,255,0.13)", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", color:"#F0EFE8", outline:"none" },
  error:      { fontSize:"13px", color:"#F05D5D", marginBottom:"12px" },
  primaryBtn: { width:"100%", padding:"15px", background:"#7C6EF8", border:"none", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", fontWeight:600, color:"#fff", cursor:"pointer", marginBottom:"12px", maxWidth:"360px" },
  googleBtn:  { width:"100%", maxWidth:"360px", padding:"14px", background:"transparent", border:"1px solid rgba(255,255,255,0.13)", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", fontWeight:500, color:"#F0EFE8", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:"10px", marginBottom:"24px" },
  link:       { fontSize:"14px", color:"#7C6EF8", textDecoration:"none" },
};